export const SET_MUSIC_PAYLOAD = "SET_MUSIC_PAYLOAD";
export const RESET_MUSIC_PLAYER_STATE = "RESET_MUSIC_PLAYER_STATE";
export const MAXIMIZE_MUSIC_PLAYER = "MAXIMIZE_MUSIC_PLAYER";
export const SUFFLED_RESET_DATA = "SUFFLED_RESET_DATA";
export const PLAY_PAUSE = "PLAY_PAUSE";
export const DISABLEPLAYER_BUTTON = "DISABLEPLAYER_BUTTON";